/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import './Actions.scss';

import { useMediaQuery } from 'react-responsive'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faChevronLeft, faChevronRight, faArrowCircleLeft} from '@fortawesome/free-solid-svg-icons'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import {useRecoilValue} from 'recoil';
import {currentGameInfoQuery} from '../recoil/selectors';
import {getImagePath} from '../Helper';
import {displayActionsState} from '../recoil/atoms';
import {useRecoilState} from 'recoil/dist';


function Actions({actions, onActionSelection}) {
  const [showActions, setShowActions] = useRecoilState(displayActionsState);
  const isMobile = useMediaQuery({maxWidth: 575});
  const isLandscape = useMediaQuery({ orientation: 'landscape', maxWidth: 850});
  // const isLandscape = useMediaQuery({ maxWidth: 1550});

  const handleToggle = () => {
    setShowActions(!showActions);
  };

  return (

      <div className="posr">
        {
          actions.length > 0 && (isMobile || isLandscape) &&
          <a className="player-actions-toggler" onClick={handleToggle}>
            <FontAwesomeIcon
                icon={faArrowCircleLeft}
                className={`icon-animate ${showActions ? 'icon-animate__rotate':''}`} />
          </a>
        }
        <div className={`player-actions 
            ${isMobile || isLandscape ? 'player-actions--mobile' : ''}
            ${showActions ? '' : 'player-actions--mobile--hide'}
            ${showActions ? '' : 'mouse--still'}
          `}>
          { actions.length > (isMobile ? 2 : 3) &&
          <CarouselProvider
              naturalSlideWidth={100}
              naturalSlideHeight={100}
              totalSlides={actions.length}
              visibleSlides={isMobile || isLandscape ? 2 : 3}
              orientation={'vertical'}
              className={'carousel__vertical'}
          >
            <ButtonBack><FontAwesomeIcon icon={faChevronLeft} /></ButtonBack>

            <Slider>
              {actions.map((a, i) => <Slide className='player-action' key={i} index={i}><Action key={a.id} action={a} onSelect={() => onActionSelection(i)}/></Slide>)}
            </Slider>

            <ButtonNext><FontAwesomeIcon icon={faChevronRight} /></ButtonNext>
          </CarouselProvider>
          }

          { actions.length <= (isMobile ? 2 : 3) &&
          <div className="player-actions__wrapper d-flex flex-column">
            {actions.map((a, i) => <div className='player-action' key={i}><Action key={a.id} action={a} onSelect={() => onActionSelection(i)}/></div>)}
          </div>
          }
        </div>
      </div>
  );
}

function Action({action, onSelect}) {
  const currentGame = useRecoilValue(currentGameInfoQuery);
  const imageUrl = getImagePath(action.thumbnail, currentGame.site, currentGame.shootId, action.fragmentId);
  return (
    <a href="#" className="d-block" onClick={
      (e) => {
        e.preventDefault();
        onSelect();
      }
    }>
      <img src={imageUrl} className="w-100" alt={action.title}/>
      <p className="player-action__text mb-0">{action.title}</p>
    </a>
  )
}

export default Actions;
